exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".section-block.no-padding[data-v-1c347def] {\n  padding: 0 !important;\n  overflow: hidden;\n}\n.section-block.no-margin[data-v-1c347def] {\n  margin: 0 !important;\n}\n.section-block h3[data-v-1c347def] {\n  text-align: center;\n  margin: 0.7em 0em;\n}\n.section-block .dashboard-inner[data-v-1c347def] {\n  width: 100%;\n}\n.section-block .dashboard-inner.limit-width[data-v-1c347def] {\n  max-width: 33em;\n  margin: auto;\n}\n", ""]);

// exports
